/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ConnectionViewDirection = (typeof ConnectionViewDirection)[keyof typeof ConnectionViewDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConnectionViewDirection = {
  pending_in: 'pending_in',
  pending_out: 'pending_out',
  accepted: 'accepted',
} as const;
